import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { AccountListPanelComponent } from './lib/account-list-panel.component'
import { AccountListKey } from './panel-key'

export const AccountListPanelConfig: PanelConfig = {
  key: AccountListKey,
  title: 'Accounts',
  description:
    'View account identifying information and reconciliation status. Load into and run accounts.',
  category: PanelCategory.ESSENTIALS,
  panelComponent: AccountListPanelComponent,
  accessPermission: 'accessAccountsPanel',
}
